function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FormControlLabel, Radio, RadioGroup } from "@material-ui/core";
import React, { PureComponent } from "react";
import { connect } from "react-redux";
import SettingItem from "@common/components/Settings/SettingItem";
import SettingsModalContentWrapper from "@common/components/Settings/SettingsModalContentWrapper";
import { changeWebSetting } from "@common/utils/helpers";
import { LAYOUT_DIRECTIONS } from "@config/constants";
var Accessibility = /*#__PURE__*/ function(SettingItem) {
    "use strict";
    _inherits(Accessibility, SettingItem);
    var _super = _create_super(Accessibility);
    function Accessibility(props) {
        _class_call_check(this, Accessibility);
        var _this;
        _this = _super.call(this, props);
        _define_property(_assert_this_initialized(_this), "onChangeHandler", function(event) {});
        _this.state = {
            audioDescription: false,
            subtitles: false
        };
        return _this;
    }
    _create_class(Accessibility, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var i18n = this.props.i18n;
                return /*#__PURE__*/ _jsx(SettingsModalContentWrapper, {
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "accessability-wrapper",
                        children: [
                            /*#__PURE__*/ _jsx("h1", {
                                className: "title",
                                children: i18n.settings.accessabilityTitle
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                className: "description",
                                children: i18n.settings.accessabilityDescription
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                className: "description-bold",
                                children: i18n.settings.accessabilityDescription2
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "wrapper",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "wrapper-content",
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "title",
                                                children: i18n.settings.audioDescription
                                            }),
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "description",
                                                children: i18n.settings.audioDescriptionDescription
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "toggle-switch",
                                        children: /*#__PURE__*/ _jsxs("label", {
                                            className: "toggle-switch-switch",
                                            tabIndex: "0",
                                            children: [
                                                /*#__PURE__*/ _jsx("input", {
                                                    ref: function(ref) {
                                                        return _this.alphabeticalFilterRef = ref;
                                                    },
                                                    type: "checkbox",
                                                    tabIndex: "-1",
                                                    onChange: function(event) {
                                                        _this.setState({
                                                            audioDescription: event.target.checked
                                                        });
                                                    },
                                                    checked: this.state.audioDescription
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "toggle-switch-slider"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "wrapper",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "wrapper-content",
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "title",
                                                children: i18n.settings.subtitles
                                            }),
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "description",
                                                children: i18n.settings.subtitlesDescription
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "toggle-switch",
                                        children: /*#__PURE__*/ _jsxs("label", {
                                            className: "toggle-switch-switch",
                                            tabIndex: "0",
                                            children: [
                                                /*#__PURE__*/ _jsx("input", {
                                                    ref: function(ref) {
                                                        return _this.alphabeticalFilterRef = ref;
                                                    },
                                                    type: "checkbox",
                                                    tabIndex: "-1",
                                                    onChange: function(event) {
                                                        _this.setState({
                                                            subtitles: event.target.checked
                                                        });
                                                    },
                                                    checked: this.state.subtitles
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "toggle-switch-slider"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                });
            }
        }
    ]);
    return Accessibility;
}(SettingItem);
var mapStateToProps = function(param) {
    var i18n = param.i18n, profileSettings = param.profileSettings;
    return {
        i18n: i18n,
        profileSettings: profileSettings
    };
};
export default connect(mapStateToProps)(Accessibility);
